export default {
  /* getMessage: field => `${field} não é um CNPJ válido.` */
  validate: value => {
    value = value.replace(/[&\/\#,+()$~%.'":*?<>{}-\s]/g, '')
    if (value.length !== 14) return false
    if (['00000000000000', '11111111111111', '22222222222222', '33333333333333', '44444444444444', '55555555555555', '66666666666666', '77777777777777', '88888888888888', '99999999999999'].indexOf(value) !== -1) return false

    let length = value.length - 2
    let numbers = value.substring(0, length)
    const digits = value.substring(length)
    let sum = 0
    let pos = length - 7
    for (let i = length; i >= 1; i--) {
      sum += numbers.charAt(length - i) * pos--
      if (pos < 2) pos = 9
    }
    let result = sum % 11 < 2 ? 0 : 11 - sum % 11
    if (result !== parseInt(digits.charAt(0))) return false

    length = length + 1
    numbers = value.substring(0, length)
    sum = 0
    pos = length - 7
    for (let i = length; i >= 1; i--) {
      sum += numbers.charAt(length - i) * pos--
      if (pos < 2) pos = 9
    }
    result = sum % 11 < 2 ? 0 : 11 - sum % 11
    if (result !== parseInt(digits.charAt(1))) return false

    return true
  }
}



// WEBPACK FOOTER //
// ./src/validators/cnpj-validator.js